import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { NavigateBeforeOutlined, Map, FilePresent, RestartAlt } from "@mui/icons-material";
import { Container, MuniSpinner2, Table } from "../../components";
import { UserContext } from "../../context";
import { getCamaras } from "./handlers";
import { Button } from "react-bootstrap";
import { useGeneralAppStore } from "../../store/generalAppStore";
import ModalMapaDePuntos from "../../views/modals/ModalMapaDePuntos";
import { tableData } from "./tableData";
import FormCamarasPorRango from "./Formularios/FormCamarasPorRango";
import { format, isAfter, parse, parseISO } from "date-fns";
import ModalInfoCamara from "../../views/modals/ModalInfoCamara";

const Camaras = () => {
  const { actions: ua } = useContext(UserContext);
  const navigate = useNavigate();
  const [camaras, setCamaras] = useState({
    data: null,
    is_loading: false,
    filtrar_por_fecha: false,
    fecha_inicio: null,
    fecha_fin: null,
    camara_seleccionada: null,
  });
  const [busqueda, setBusqueda] = useState("");

  const { modals, handlerModal } = useGeneralAppStore();

  useEffect(() => {
    const camaras = async () => {
      if (ua.hasPermission("camaras.view.general")) {
        await getCamaras(setCamaras);
      } else {
        navigate("/");
        return;
      }
    };

    camaras();
  }, []);

  const dataFiltrada = camaras?.data?.filter((cam) =>
    cam.lugar.toLowerCase().includes(busqueda.toLowerCase())
  );

  return (
    <Container>
      <Link className={`btn btn-primary mb-3`} to={"/"}>
        <NavigateBeforeOutlined style={{ marginLeft: "-8px" }} />
        Volver
      </Link>
      <h2 className="text-decoration-underline">Cámaras</h2>

      <div className="d-flex align-items-center mb-2">
        <label htmlFor="filtrar_por_fecha" className="me-3">
          Filtrar por fecha de deteccion de la infracción
        </label>
        <input
          type="checkbox"
          id="filtrar_por_fecha"
          className="form-check-input mt-0"
          style={{
            width: "1rem",
            height: "1rem",
            marginBottom: "2px",
            backgroundColor: camaras.filtrar_por_fecha ? "#1334C9" : "transparent",
            borderColor: camaras.filtrar_por_fecha ? "#1334C9" : "#CCC",
          }}
          // defaultChecked={false}
          checked={camaras.filtrar_por_fecha}
          onChange={(e) =>
            setCamaras((prevState) => ({
              ...prevState,
              filtrar_por_fecha: e.target.checked,
            }))
          }
        />
      </div>

      {camaras.filtrar_por_fecha && <FormCamarasPorRango setCamaras={setCamaras} />}

      <hr />

      <div className="mt-3">
        {camaras.is_loading ? (
          <MuniSpinner2 />
        ) : camaras.data ? (
          <>
            {camaras.filtrar_por_fecha && camaras.fecha_inicio && camaras.fecha_fin && (
              <div className="mb-3">
                <label>
                  Filtrado por fechas: {format(parseISO(camaras.fecha_inicio), "dd/MM/yyyy")} -{" "}
                  {format(parseISO(camaras.fecha_fin), "dd/MM/yyyy")}
                </label>
              </div>
            )}
            {ua.hasPermission("camaras.view.general") && (
              <div className="mb-3">
                <Button
                  onClick={() => handlerModal({ modal: true, modalName: "mapa_de_puntos" })}
                  className="me-2"
                >
                  <Map /> Mapa
                </Button>
                <Button
                  onClick={() => {
                    getCamaras(setCamaras);
                    setBusqueda("");
                  }}
                >
                  <RestartAlt /> Reiniciar
                </Button>
              </div>
            )}
            <div className="d-flex flex-column mb-3" style={{ maxWidth: "320px" }}>
              <label htmlFor="busqueda">Búsqueda por Lugar</label>
              <input
                type="text"
                id="busqueda"
                className="form-control"
                placeholder="Lugar"
                onChange={(e) => setBusqueda(e.target.value)}
              />
            </div>
            <Table
              data={busqueda === "" ? tableData(camaras.data) : tableData(dataFiltrada)}
              getRowClassName={(e) => {              
                if (
                  e.row.fecha_colocacion &&
                  camaras.filtrar_por_fecha &&
                  camaras?.fecha_fin &&
                  isAfter(format(parse(e.row.fecha_colocacion, "dd/MM/yyyy HH:mm", new Date()), "yyyy-MM-dd"), format(camaras?.fecha_fin + " 23:59:59", 'yyyy-MM-dd'))
                ) {
                  return "camaraOcultadaEnMapa";
                }
                return null;
              }}
              rowClick={(e) => {
                /* if (
                  e.row.fecha_colocacion &&
                  camaras.filtrar_por_fecha &&
                  camaras?.fecha_fin &&
                  isAfter(
                    parse(e.row.fecha_colocacion, "dd/MM/yyyy HH:mm", new Date()), "yyyy-MM-dd",
                    camaras?.fecha_fin
                  )
                ) {
                  return;
                } */
                setCamaras((prevState) => ({
                  ...prevState,
                  camara_seleccionada: e.row,
                }));
                handlerModal({ modal: true, modalName: "info_camara" });
              }}
              name="actas"
            />
          </>
        ) : null}
      </div>

      {modals.includes("mapa_de_puntos") && camaras.data && (
        <ModalMapaDePuntos camaras={camaras} setCamaras={setCamaras} />
      )}
      {modals.includes("info_camara") && camaras.data && camaras.camara_seleccionada && (
        <ModalInfoCamara camaras={camaras} setCamaras={setCamaras} />
      )}
    </Container>
  );
};

export default Camaras;
